module.exports = __webpack_public_path__ + "img/hexagon.6f7e1d7a.png";